"use client";

import Link from "next/link";

import { Avatar, AvatarSize } from "@/app/(discover)/components/avatar";
import { profileAvatarDataTestIds } from "@/lib/data-test-ids/profile.data-test-ids";
import { getInitials } from "@/lib/helpers/initials";
import routes from "@/lib/routes";
import { User } from "@/lib/types/auth";

export interface ProfileAvatarProps {
  user: User;
  size: AvatarSize;
  className?: string;
}

export function ProfileAvatar({ user, size, className }: ProfileAvatarProps) {
  const initials = getInitials(user.name, 2);

  return (
    <Link
      href={routes.getProfileInfo()}
      className={className}
      title={`View Profile - ${user.name}`}
      data-testid={profileAvatarDataTestIds.PROFILE_AVATAR_LINK}
    >
      <Avatar
        initials={initials}
        size={size}
        testId={profileAvatarDataTestIds.PROFILE_AVATAR}
        className="mb-1 group-hover:ring-2 group-hover:ring-line-strong"
      />
      <span className="text-xs font-medium">Profile</span>
    </Link>
  );
}
